<template>
    <a-modal :title="`支付第一次入驻服务费(${props.tableColumnsData.full_name})`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 6 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-row>
                    <a-col :span="24">
                        <a-form-item label="入驻地址">
                            {{ props.tableColumnsData.full_address_number }}
                        </a-form-item>
                    </a-col>
                    <a-col :span="8" :offset="3">
                        <a-form-item label="入驻开始时间" :labelCol="{ span: 9 }">
                            {{ props.tableColumnsData.enter_starttime }}
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" :offset="1">
                        <a-form-item label="入驻结束时间">
                            {{ props.tableColumnsData.enter_endtime }}
                        </a-form-item>
                    </a-col>
                    <a-col :span="8" :offset="4">
                        <a-form-item label="收费类型" v-if="props.tableColumnsData.payment_type == 3">
                            {{ props.tableColumnsData.other_name }}
                        </a-form-item>
                        <a-form-item label="收费类型" v-else> 【{{ props.tableColumnsData.fee_standard == 2 ? '一次性收费' :
                            '按年收费' }}】
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="代理商姓名">
                            {{ props.tableColumnsData.seller }}
                        </a-form-item>
                    </a-col>
                </a-row>
                <div>
                    <a-form-item label="付款方式">
                        <a-radio-group v-model:value="formData.type" button-style="solid">
                            <a-radio :value="8" v-if="state.allowed_pay_type.indexOf(8) != -1">微信扫码付款</a-radio>
                            <a-radio :value="4" v-if="state.allowed_pay_type.indexOf(4) != -1">服务商余额支付</a-radio>
                            <a-radio :value="3" v-if="state.allowed_pay_type.indexOf(3) != -1">平台余额支付</a-radio>
                            <a-radio :value="1" v-if="state.allowed_pay_type.indexOf(1) != -1">对公账户</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <div v-if="formData.type == 1">
                        <a-form-item label="对公账号信息">
                            <a-tag v-html="state.bank_info" v-if="state.bank_info" color="orange"
                                @click="handleCopyClick(state.bank_info)" style="cursor: pointer;"></a-tag>
                        </a-form-item>
                        <a-form-item label="附件" name="attachment" required>
                            <Upload :upload_path="props.tableColumnsData.upload_path"
                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" uploadType="text"
                                v-model:value="formData.attachment" :limitation="99" uploadText="上传附件">
                            </Upload>
                        </a-form-item>
                        <a-form-item label="上传的附件中显示的到账金额" name="public_money" required>
                            <a-input v-model:value="formData.public_money" placeholder="请输入付款金额"
                                style="width: 400px"></a-input>
                        </a-form-item>
                        <a-form-item label="是否多公司付款" name="is_duo" required>
                            <a-radio-group v-model:value="formData.is_duo" button-style="solid">
                                <a-radio-button :value="1">是</a-radio-button>
                                <a-radio-button :value="2">否</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item label="更多公司名称" name="is_duo_name" v-if="formData.is_duo == 1">
                            <a-select allow-clear placeholder="请输入公司名称" style="width: 600px" optionLabelProp="label"
                                v-model:value="companyData.companyName" show-search :default-active-first-option="false"
                                :show-arrow="false" :filter-option="false" :not-found-content="null"
                                @search="handleSearch" @change="handleChange">
                                <a-select-option v-for="(optionsItem, optionsIndex) in state.options"
                                    :key="optionsIndex" :value="optionsItem.id" :label="optionsItem.full_name"
                                    :title="optionsItem">
                                    <a-tooltip>
                                        <template #title> {{ optionsItem.full_name2 }}</template>
                                        {{ optionsItem.full_name2 }}
                                    </a-tooltip>
                                </a-select-option>
                            </a-select>
                            <div>
                                <a-row>
                                    <a-col :span="12">{{ props.tableColumnsData.full_name }}</a-col>
                                    <a-col :span="8">到账金额：{{ calcDaozhangMoney }}元</a-col>
                                    <a-col :span="4"></a-col>
                                </a-row>
                                <a-row v-for="item in formData.is_duo_list">
                                    <a-col :span="12">{{ item.full_name }}</a-col>
                                    <a-col :span="8"><a-input v-model:value="item.public_money" placeholder="到账金额"
                                            addonAfter="元" style="width: 150px"></a-input></a-col>
                                    <a-col :span="4">
                                        <CloseCircleOutlined style="color: red" @click="delDuoItem(item)" />
                                    </a-col>
                                </a-row>
                            </div>
                        </a-form-item>

                        <a-form-item label="备注">
                            <a-textarea v-model:value="formData.remark" placeholder="请输入备注"
                                style="width: 400px"></a-textarea>
                        </a-form-item>
                    </div>
                    <div v-if="formData.type == 8">
                        <a-form-item label="付款方">
                            <a-radio-group v-model:value="formData.wx_payer" button-style="solid">
                                <a-radio-button :value="1">代理商付款身份付款</a-radio-button>
                                <a-radio-button :value="2">续费联系人身份付款</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item label="需要支付金额">
                            <template v-if="formData.wx_payer == 1" title="代理商付款">
                                <div style="font-size: 24px; color: red; line-height: 24px">
                                    <div v-if="state.coupon_use_id >= 1">
                                        <span class="red" style="text-decoration: line-through">￥{{
                                            state.pay_amount_total }} </span>
                                        <span>，优惠了￥{{ state.discount_amount_total }}</span>
                                        <a-button type="primary" @click="useCoupon"
                                            style="background: #ff6b26; margin-left: 10px" size="small"
                                            v-if="state.isselected_coupon">
                                            使用了优惠券（{{ state.isselected_coupon.coupon_type == 1 ? '直减现金券' :
                                                state.isselected_coupon.coupon_type == 2 ? '满减现金券' : '折扣券' }}：{{
                                                state.isselected_coupon.name
                                            }}√）</a-button>
                                        <a style="margin-left: 20px; font-size: 14px" @click="deleteCoupon">删除优惠券</a>
                                    </div>
                                    <div v-else>￥{{ props.tableColumnsData.PayMoney }}<a-button type="primary"
                                            @click="useCoupon" style="background: #ff6b26; margin-left: 10px"
                                            size="small">使用优惠券</a-button></div>
                                </div>
                            </template>
                            <template v-if="formData.wx_payer == 2" title="续费联系人付款">
                                <div>
                                    <div v-if="state.cust_paid_editable">
                                        <a-input v-model:value="state.cust_paid_total" style="width: 80px"
                                            @pressEnter="saveCustPrice()" />
                                        <check-outlined class="editable-cell-icon-check" @click="saveCustPrice()" />
                                    </div>
                                    <div v-else>
                                        <span style="font-size: 24px; color: red; line-height: 24px" class="red">￥{{
                                            state.cust_paid_total }}</span>
                                        <edit-outlined class="editable-cell-icon ml-1x" @click="editCustPrice()" />
                                    </div>
                                </div>
                            </template>
                        </a-form-item>
                        <a-form-item label="优惠后需要支付金额" v-if="state.coupon_use_id >= 1">
                            <div style="font-size: 24px; color: red; margin-top: -4px">￥{{ state.actually_paid_total }}
                            </div>
                        </a-form-item>
                        <a-form-item label="操作">
                            <a-button type="primary" @click="onFormSubmit">点击弹出付款二维码</a-button>
                        </a-form-item>
                    </div>
                    <div v-else-if="formData.type == 4 || formData.type == 3">
                        <a-form-item label="服务商余额" v-if="formData.type == 4">
                            ￥{{ state.moeny }}
                            <a @click="recharge" class="m-3x">服务商余额充值</a>
                        </a-form-item>
                        <a-form-item label="平台余额" v-if="formData.type == 3">
                            ￥{{ state.walletPlatform }}
                            <a @click="platformRecharge" class="m-3x">平台余额充值</a>
                        </a-form-item>


                        <!-- 服务商余额充值 -->
                        <PlatformBalanceCharge v-if="state.platformVisible" @cancel="handleOk" @ok="handleOk"
                            :customerPlatformId="props.tableColumnsData.platform_id" :bussType="1">
                        </PlatformBalanceCharge>
                        <!-- 平台余额充值 -->
                        <PlatformBalanceCharge v-if="state.platformVisible2" @cancel="handleOk" @ok="handleOk"
                            :platformId="props.tableColumnsData.platform_id" :bussType="2">
                        </PlatformBalanceCharge>

                        <a-form-item label="需要支付金额">
                            <div style="font-size: 24px; color: red; line-height: 24px">
                                <div v-if="state.coupon_use_id >= 1">
                                    <span class="red" style="text-decoration: line-through">￥{{ state.pay_amount_total
                                        }}
                                    </span>
                                    <span>，优惠了￥{{ state.discount_amount_total }}</span>
                                    <a-button type="primary" @click="useCoupon"
                                        style="background: #ff6b26; margin-left: 10px" size="small"
                                        v-if="state.isselected_coupon">
                                        使用了优惠券（{{ state.isselected_coupon.coupon_type == 1 ? '直减现金券' :
                                            state.isselected_coupon.coupon_type == 2 ? '满减现金券' : '折扣券' }}：{{
                                            state.isselected_coupon.name
                                        }}√）</a-button>
                                    <a style="margin-left: 20px; font-size: 14px" @click="deleteCoupon">删除优惠券</a>
                                </div>
                                <div v-else>￥{{ props.tableColumnsData.PayMoney }}<a-button type="primary"
                                        @click="useCoupon" style="background: #ff6b26; margin-left: 10px"
                                        size="small">使用优惠券</a-button></div>
                            </div>
                        </a-form-item>
                        <a-form-item label="优惠后需要支付金额" v-if="state.coupon_use_id >= 1">
                            <div style="font-size: 24px; color: red; margin-top: -4px">￥{{ state.actually_paid_total }}
                            </div>
                        </a-form-item>
                        <a-form-item label="备注">
                            <a-textarea v-model:value="formData.remark" placeholder="请输入备注"
                                style="width: 400px"></a-textarea>
                        </a-form-item>
                    </div>
                </div>
            </a-form>
        </a-skeleton>
    </a-modal>
    <UseCoupons v-if="state.showCoupon" v-model:couponId="state.coupon_use_id"
        :tableColumnsData="{ public_payment_type: 1, customer_list: null, id: props.tableColumnsData.id }" @cancel="
            () => {
                state.showCoupon = false
            }
        " @ok="UseCouponsOk"></UseCoupons>
    <!-- 微信扫码支付 -->
    <WechatPayQrcode v-if="state.showQrcode" :qrcodeData="state.qrcodeData" @cancel="state.showQrcode = false" @ok="
        () => {
            emit('ok')
        }
    "></WechatPayQrcode>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import { PlusOutlined, EditOutlined, CheckOutlined, CloseCircleOutlined } from '@ant-design/icons-vue'
import baseService from '@/utils/http/axios'
import SvgIcon from '@/components/SvgIcon/index.vue'
import { reactive, onMounted, ref, h, onUnmounted, computed } from 'vue'
import PlatformBalanceCharge from './../../financialManagement/components/PlatformBalanceCharge.vue'
import { useStore } from 'vuex'
import dayjs from 'dayjs'
import Upload from '@/components/base/Upload.vue'
import UseCoupons from '@/components/base/UseCoupons.vue'
import WechatPayQrcode from '@/components/base/WechatPayQrcode.vue'
import { stat } from 'fs'
import { anyType } from 'ant-design-vue/es/_util/type'
const format = 'YYYY-MM-DD'
const $store = useStore()
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})
const timesOption = [
    { label: '1个月', value: 1 },
    { label: '2个月', value: 2 },
    { label: '3个月', value: 3 },
    { label: '4个月', value: 4 },
    { label: '5个月', value: 5 },
    { label: '6个月', value: 6 },
    { label: '7个月', value: 7 },
    { label: '8个月', value: 8 },
    { label: '9个月', value: 9 },
    { label: '10个月', value: 10 },
    { label: '11个月', value: 11 },
    { label: '1年', value: 12 },
    { label: '2年', value: 24 },
    { label: '3年', value: 36 },
    { label: '4年', value: 48 },
    { label: '5年（一次性）', value: 60 }
]
const state = reactive<any>({
    showQrcode: false, //微信支付二维码
    qrcodeData: {},
    moeny: undefined,
    walletPlatform: undefined,
    loading: false,
    submitLoading: false,
    platformVisible: false,
    platformVisible2: false,
    showCoupon: false,
    doaction: 2,
    doaction2: 3,
    result: 1,
    year_quantity: 12,
    fee_standard: null,
    discount_amount_total: 0, // 总优惠金额
    pay_amount_total: 0, // 总应付金额
    actually_paid_total: 0, // 总实付金额
    cust_paid_total: 0, // 总客户应付金额
    cust_paid_editable: false,
    customer_xfdata: [],
    coupon_use_list: [], // 优惠券列表
    coupon_use_id: null, // 选中优惠券id
    isselected_coupon: {}, //选中的优惠券
    allowed_pay_type: [], //允许支付方式
    bank_info: '', //对公转账银行信息
})
const formData = reactive<any>({
    type: 2,
    wx_payer: 1, //微信支付付款人，1代理商，2续费联系人
    is_duo: null,//是否多公司一起对公转账
    is_duo_list: [],
})
const useCoupon = () => {
    state.showCoupon = true
}
onMounted(() => {
    queryMoney()
    getComputeOreder()
    //默认二维码支付-获取微信支付二维码
    formData.type = 8
})
const UseCouponsOk = (e) => {
    state.coupon_use_id = e.id
    state.isselected_coupon = e
    state.showCoupon = false
    getComputeOreder()
}
const deleteCoupon = () => {
    state.isselected_coupon = {}
    state.coupon_use_id = null
    getComputeOreder()
}
// 计算订单-支付第一次入驻服务费
const getComputeOreder = () => {
    state.priceLoading = true
    let requeryParam = {
        url: `/admin/v1/getComputeOreder`,
        method: 'post',
        data: {
            public_payment_type: 1, //支付注册费
            customer_id: props.tableColumnsData.id,
            month_quantity: 12,
            fee_standard: props.tableColumnsData.fee_standard, //按年收费
            coupon_use_id: state.coupon_use_id
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            state.priceLoading = false
            state.coupon_use_list = res.data.coupon_use_list
            state.allowed_pay_type = res.data.allowed_pay_type
            state.discount_amount_total = res.data.oreder.discount_amount_total // 总优惠金额
            state.pay_amount_total = res.data.oreder.pay_amount_total // 总应付金额
            state.actually_paid_total = res.data.oreder.actually_paid_total // 总实付金额
            state.cust_paid_total = res.data.oreder.cust_paid_total // 总实付金额（客户）
            state.customer_xfdata = res.data.oreder.customer_xfdata // 总实付金额
            state.bank_info = res.data.bank_info
            //默认选中支持的支付方式
            if (state.allowed_pay_type.indexOf(formData.type) == -1 && formData.type != 0) {
                formData.type = state.allowed_pay_type[0]
            }
        })
        .catch((res) => {
            message.error(res?.msg ? res.msg : '查询订单失败')
            state.priceLoading = false
            if (res?.data == 'coupon') {
                //优惠券问题，删除此优惠券
                deleteCoupon()
            }
        })
}

const recharge = () => {
    state.platformVisible = true
}
const platformRecharge = () => {
    state.platformVisible2 = true
}
const handleOk = () => {
    state.platformVisible = false
    state.platformVisible2 = false
    //刷新余额
    queryMoney()
}

const queryMoney = () => {
    state.loading = true
    let requeryParam = {
        url: '/admin/user/getMoney?customer_id=' + props.tableColumnsData.id,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            state.loading = false
            state.moeny = res.data.money
            state.walletPlatform = res.data.walletPlatform
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取余额失败')
            }
        })
}

// 提交
const onFormSubmit = () => {

    state.submitLoading = true
    let obj: any = {}
    if (formData.type == 1) {
        //对公转账
        obj = {
            public_payment_type: 1, //支付注册费
            fee_standard: props.tableColumnsData.fee_standard, //收费时间按照主表12个月
            month_quantity: null,
            belonger: props.tableColumnsData.seller, //代理商
            coupon_use_id: null, //对公不能使用优惠券
            payment_method: 1, //对公转账
            remark: formData.remark, //付款备注
            attachment: formData.attachment, //附件、对公才传附件
            public_money: formData.public_money
        }
        if (formData.is_duo == 1) {
            if (formData.is_duo_list.length == 0) {
                message.error('请选择其他对公转账公司')
                state.submitLoading = false
                return
            }
            let shengyu = formData.public_money
            let err = false
            formData.is_duo_list.forEach((item: any) => {
                if (!item.public_money || item.public_money <= 0) {
                    message.error('请输入每个主体对公转账金额')
                    state.submitLoading = false
                    err = true
                    return
                }
                shengyu -= item.public_money
            })
            if (err) {
                return
            }
            if (shengyu <= 0) {
                message.error('对公转账金额不能大于总金额')
                state.submitLoading = false
                return
            }
            obj.customer_list = formData.is_duo_list.map((item: any) => {
                return {
                    customer_id: item.id,
                    month_quantity: 12,
                    coupon_amount: 0,
                    full_name: item.full_name,
                    public_money: item.public_money
                }
            })
            obj.customer_list.push({
                customer_id: props.tableColumnsData.id,
                month_quantity: 12,
                coupon_amount: 0,
                full_name: props.tableColumnsData.full_name,
                public_money: shengyu
            })
        } else {
            obj.customer_id = props.tableColumnsData.id
        }
    } else if (formData.type == 8) {
        //微信扫码支付
        obj = {
            public_payment_type: 1, //支付注册费
            customer_id: props.tableColumnsData.id, //客户id
            fee_standard: props.tableColumnsData.fee_standard, //收费时间按照主表12个月
            month_quantity: null,
            belonger: props.tableColumnsData.seller, //代理商
            coupon_use_id: state.coupon_use_id, //余额抵扣可以用优惠券
            payment_method: 8, //微信支付
            remark: formData.remark, //付款备注
            wx_payer: formData.wx_payer //微信支付特有的2项
        }
    } else if (formData.type == 4 || formData.type == 3) {
        //余额抵扣
        obj = {
            public_payment_type: 1, //支付注册费
            customer_id: props.tableColumnsData.id, //客户id
            fee_standard: props.tableColumnsData.fee_standard, //收费时间按照主表12个月
            month_quantity: null,
            belonger: props.tableColumnsData.seller, //代理商
            coupon_use_id: state.coupon_use_id, //余额抵扣可以用优惠券
            payment_method: formData.type, //余额抵扣
            remark: formData.remark //付款备注
        }
    }
    let requeryParam = {
        url: '/admin/v1/payOreder',
        method: 'post',
        data: obj
    }
    baseService(requeryParam)
        .then((res: any) => {
            if (res.msg == 'showqrcode') {
                //显示微信扫的二维码
                state.qrcodeData = {
                    qrcode: res.data.code_url, //二维码url
                    qrcode_money: res.data.qrcode_money, //金额
                    payment_record_id: res.data.payment_record_id, //记录id
                    full_name: props.tableColumnsData.full_name, //名称
                    trade_type: res.data.trade_type
                }
                state.showQrcode = true
            } else {
                message.success(res.msg)
                emit('ok')
            }
            state.submitLoading = false
        })
        .catch((res) => {
            state.submitLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })

}

const cancel = () => {
    emit('cancel')
}
//编辑续费联系人付款
const editCustPrice = () => {
    state.cust_paid_editable = true
}
const saveCustPrice = () => {
    let requeryParam = {
        url: '/admin/v1/updateCustPaid',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id, //客户id
            new_price: state.cust_paid_total,
            month_quantity: null,
            public_payment_type: 1
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            message.success(res.msg)
            state.cust_paid_editable = false
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('修改失败')
            }
        })
}
// 复制
const handleCopyClick = (val) => {
    // 将HTML转换为带换行符的文本
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = val

    // 获取所有div内容并过滤掉空内容，然后用换行符连接
    const divs = tempDiv.getElementsByTagName('div')
    const textArray = Array.from(divs)
        .map(div => div.textContent || div.innerText)
        .filter(text => text.trim() !== '')  // 过滤掉空内容

    // 使用一个换行符连接
    const plainText = textArray.join('\n')

    // 使用textarea保存格式
    var textarea = document.createElement('textarea')
    textarea.value = plainText
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    message.success('复制成功!')
    document.body.removeChild(textarea)
}
//对公转账多个公司的相关方法
const companyData = reactive<any>({})
let timer: any = null
const handleSearch = (e) => {
    clearTimeout(timer)
    if (e == '') {
        state.options = []
        return
    }
    timer = setTimeout(() => {
        let requestParam = {
            url: '/admin/v1/customerSearchAll?checkpermission=2&keyword=' + e + '&platform_id=' + props.tableColumnsData.platform_id,
            method: 'get'
        }
        baseService(requestParam)
            .then((res) => {
                state.options = res.data.list
            })
            .catch((res) => {
                state.options = []
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('查询失败')
                }
            })
    }, 500)
}
const handleChange = (e, val) => {
    if (val.title.checkpermission == 2) {
        message.error('您没有此平台的万能支付权限')
        companyData.companyName = ''
        return
    } else if (val.title.checkpermission == 3) {
        message.error('该主体在续费保护期内，只能由原代理商续费，请联系原代理商协商！')
        companyData.companyName = ''
        return
    }
    if (val.title.id != props.tableColumnsData.id) {//不能添加当前单位
        //判断list中是否有数据
        let haveId = formData.is_duo_list.find((item) => {
            return item.id == val.title.id
        })
        if (!haveId) {
            formData.is_duo_list.push({
                id: val.title.id,
                full_name: val.title.full_name,
                public_money: 0,
            })
        }
    }
    companyData.companyName = ''
}
const delDuoItem = (val) => {
    formData.is_duo_list = formData.is_duo_list.filter((item) => {
        return item.id != val.id
    })
}
// 定义计算属性
const calcDaozhangMoney = computed(() => {
    let total = formData.public_money ?? 0
    formData.is_duo_list.forEach((item) => {
        let son_money = item.public_money ?? 0
        total -= son_money
    })
    return total.toFixed(2)
})
</script>

<style lang="less" scoped>
:deep(.ant-modal-title) {
    margin-bottom: 25px !important;
}

.label-form-item {
    display: flex;
    align-items: center;

    .delete-icon {
        color: red;
        font-size: 16px;
        cursor: pointer;
        margin-left: 10px;
    }
}

.select-color {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .label-color-picker {
        border: 1px solid #dcdfe6;
        padding: 4px;
        border-radius: 4px;
    }
}
</style>
